import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";

import { map } from "rxjs";

import {
    ENABLE_CART_REDESIGN,
    FeatureFlagFacade,
} from "@hermes/hermes-web-states-flipper-state";

export function canMatchCartDeprecated(): CanMatchFn {
    return () => {
        const featureFlagFacade = inject(FeatureFlagFacade);

        return featureFlagFacade
            .isActivated(ENABLE_CART_REDESIGN)
            .pipe(map((enabled) => !enabled));
    };
}
